export default destination => {
  destination = (destination || '').trim();

  if (destination.indexOf('//') === 0 || destination.indexOf('http') === 0) {
    return '/';
  }

  return `/${destination}`.replace(/^\/*/, '/');
};
